
 
export class storeMedicationAction {
    static readonly type = '[medicationobj] Medicationobj';

    constructor(public payload: any) {
    }
}